import App from 'app/app.js';
import 'app/store/LooksStore.js';
import Order from 'app/service/Order.js';

function OrderLine(orderable, orderLineDetails, orderPromotion, salesPrice, shipToLocation) {
  this.orderable = orderable;
  this.orderLineDetails = orderLineDetails;
  this.orderPromotion = orderPromotion || [];
  this.salesPrice = salesPrice;
  this.shipToLocation = shipToLocation;
}

export function OrderLineDetail(item, look) {
  this.item = item;
  this.look = look;
}

function createOrderLineFromData(orderLineData, restoreContext) {
  let orderLine;
  if (orderLineData.orderLineDetails) {
    const defaultLook = restoreContext?.looksStore.getDefaultLook(restoreContext.jobKey);

    orderLine = new OrderLine(
      orderLineData.orderable,
      orderLineData.orderLineDetails.map((orderLineDetail) => {
        let look;

        if (orderLineDetail.look) {
          look =
            restoreContext?.looksStore.getLookByLayoutThemeId(
              orderLineDetail.look.layoutThemeID,
              restoreContext.jobKey
            ) ||
            defaultLook ||
            orderLineDetail.look;
        }

        const restoredOrderLineDetail = new OrderLineDetail(orderLineDetail.item, look);
        restoredOrderLineDetail.restored = orderLineDetail.restored;
        return restoredOrderLineDetail;
      }),
      orderLineData.orderPromotion,
      orderLineData.salesPrice
    );
  } else {
    orderLine = new OrderLine(
      orderLineData.orderable,
      undefined,
      orderLineData.orderPromotion,
      orderLineData.salesPrice
    );
  }
  return orderLine;
}

OrderLine.prototype.clone = function () {
  return createOrderLineFromData(this);
};

OrderLine.prototype.getSalesPrice = function () {
  // return salesPrice if available otherwise return the unitPrice
  // salesPrice is set from a response back from the pricing service
  return this.salesPrice || this.orderable.unitPrice;
};

OrderLine.prototype.getUnitPrice = function () {
  return this.orderable.unitPrice;
};

OrderLine.prototype.getSlashThroughPriceDiscount = function () {
  return this.orderable.slashThroughPrice ? this.orderable.slashThroughPrice - this.orderable.unitPrice : 0;
};

function OrderLineFactory(LooksStore) {
  return {
    createFromPackage: function (orderable, jobKey) {
      // Package
      // Creating order line detail for item inside package
      var orderItemDetails = [];
      var orderUpgradeDetails = [];
      // Create order lines for items
      if (!!orderable && !!orderable.items) {
        orderItemDetails = orderable.items.map(function (item) {
          return new OrderLineDetail(item, LooksStore.getDefaultLook(jobKey));
        });
      }
      // Creating order lines for upgrades
      if (!!orderable && !!orderable.upgrades) {
        orderUpgradeDetails = orderable.upgrades.map(function (item) {
          return new OrderLineDetail(item);
        });
      }
      return new OrderLine(orderable, R.concat(orderItemDetails, orderUpgradeDetails));
    },

    createFromAddOn: function (orderable, look) {
      return new OrderLine(orderable, [new OrderLineDetail(orderable, look)]);
    },

    createFromEnhancement: function (orderable) {
      return new OrderLine(orderable, [new OrderLineDetail(orderable)]);
    },

    createFromBundle: function (orderable) {
      // Bundle
      // Creating order line detail for item inside bundle
      var orderItemDetails = [];
      var orderUpgradeDetails = [];
      // Create orderline for items if items are present.
      if (orderable.items) {
        orderItemDetails = orderable.items.map(function (item) {
          return new OrderLineDetail(item, LooksStore.getDefaultLook());
        });
      }
      // Creating order line detail for upgrade inside bundle
      if (orderable.upgrades) {
        orderUpgradeDetails = orderable.upgrades.map(function (item) {
          return new OrderLineDetail(item);
        });
      }
      return new OrderLine(orderable, R.concat(orderItemDetails, orderUpgradeDetails));
    },

    createFromCyop: function (orderable, oldOrderLine) {
      // create order line for each point
      var orderLineDetails = R.map(
        function () {
          return new OrderLineDetail();
        },
        R.range(0, orderable.points)
      );
      var orderLine = new OrderLine(orderable, orderLineDetails);
      if (oldOrderLine) {
        // copy old orderLine to new ordeLine
        orderLine.orderLineDetails = R.mapIndexed(function (d, i) {
          return R.clone(oldOrderLine.orderLineDetails[i]) || d;
        })(orderLine.orderLineDetails);
      }
      return orderLine;
    },

    createFromData: createOrderLineFromData,

    createOrder: function (orderData) {
      return new Order(orderData);
    },
    createOrderLineItemSelections: function (orderLineDetail, fields) {
      orderLineDetail.item.orderLineItemSelections = R.map(function (field) {
        return {
          selectionFieldName: field.name,
          label: field.label,
          type: field.labType,
          value: field.value
        };
      })(fields);
      return orderLineDetail;
    },
    createEnhancedPayOnlyPackage: function (orderable) {
      var orderLineDetails = orderable.items.map(function (item) {
        return new OrderLineDetail(item);
      });

      return new OrderLine(orderable, orderLineDetails);
    }
  };
}

App.factory('OrderLineFactory', ['LooksStore', OrderLineFactory]);
